/**
 * Aktif dil listesini API’den alır, i18n’i genişletir, Redux dilini geçerli kodlarla hizalar.
 * MainLayout içinde (SiteCmsSync) diğer CMS hook’larından önce çalıştırılmalıdır.
 */
import { useEffect } from 'react'
import { useDispatch } from 'react-redux'
import { store } from '../../app/store'
import { setLanguage } from '../language/languageSlice'
import { DEFAULT_SITE_LANGUAGES, setSiteLanguages, setSiteLanguagesLoading } from './siteLocaleSlice'
import { fetchSiteLanguages } from './fetchSiteLanguages'
import { seedI18nLanguageIfNeeded } from './seedI18nForSiteLanguage'
import i18n from '../../i18n'
import { ensureLocalesLoaded } from '../../i18n/ensureLocalesLoaded.js'

export function useSiteLanguagesBootstrap() {
  const dispatch = useDispatch()

  useEffect(() => {
    let cancelled = false
    dispatch(setSiteLanguagesLoading())
    void (async () => {
      try {
        const items = await fetchSiteLanguages()
        if (cancelled) return
        const list = items && items.length > 0 ? items : DEFAULT_SITE_LANGUAGES
        dispatch(setSiteLanguages(list))
        for (const { code } of list) {
          await seedI18nLanguageIfNeeded(code)
        }

        const codes = list.map((x) => x.code)
        const cur = store.getState().language.currentLanguage
        if (!codes.includes(cur)) {
          const next = codes[0] || 'tr'
          dispatch(setLanguage(next))
          await ensureLocalesLoaded(next)
          await i18n.changeLanguage(next)
          document.documentElement.lang = next
        } else {
          await ensureLocalesLoaded(cur)
          await i18n.changeLanguage(cur)
          document.documentElement.lang = cur
        }
      } catch {
        if (cancelled) return
        dispatch(setSiteLanguages(DEFAULT_SITE_LANGUAGES))
        for (const { code } of DEFAULT_SITE_LANGUAGES) {
          await seedI18nLanguageIfNeeded(code)
        }
      }
    })()
    return () => {
      cancelled = true
    }
  }, [dispatch])
}
